if (!customElements.get('yrp-new-in-products')) {
  customElements.define('yrp-new-in-products', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.grid = this.querySelector('#product-grid');
      if (!this.form || !this.grid || this.records) return;
      const sizeNames = ['size', 'sizes', 'größe', 'grösse', 'groesse', 'taille'];
      const colorNames = ['color', 'colour', 'farbe', 'couleur'];
      this.records = [...this.grid.querySelectorAll('[data-new-in-card]')].map((card, index) => {
        let options = [], variants = [], colors = [];
        try { options = JSON.parse(card.dataset.options); variants = JSON.parse(card.dataset.variants); colors = JSON.parse(card.dataset.colors || '[]') || []; } catch {}
        const sizeIndex = options.findIndex(option => sizeNames.includes(option.name.toLowerCase()));
        const colorIndex = options.findIndex(option => colorNames.includes(option.name.toLowerCase()));
        const variantsData = variants.map(variant => ({
          size: sizeIndex >= 0 ? variant.options[sizeIndex] : '',
          color: colorIndex >= 0 ? variant.options[colorIndex] : '',
          available: variant.available
        }));
        return {card, index, brand:card.dataset.brand, price:Number(card.dataset.price), available:card.dataset.available === 'true', colors:Array.isArray(colors) ? colors : [colors], variants:variantsData};
      });
      const brandSelect = this.form.elements.namedItem('brand');
      if (brandSelect) {
        const brands = [...new Set(this.records.map(record => record.brand).filter(Boolean))];
        brands.sort((a,b) => a.localeCompare(b)).forEach(value => brandSelect.add(new Option(value,value)));
        brandSelect.closest('label').hidden = brands.length === 0;
      }
      const sizes = [...new Set(this.records.flatMap(record => record.variants.map(variant => variant.size)).filter(Boolean))];
      const sizeList = this.form.querySelector('[data-local-sizes]');
      sizes.sort((a,b) => a.localeCompare(b, undefined, {numeric:true})).forEach(value => {
        const label = document.createElement('label');
        label.className = 'yrp-filter-choice yrp-filter-choice--size';
        const input = document.createElement('input');
        input.type = 'checkbox'; input.name = 'size'; input.value = value; input.className = 'visually-hidden';
        const text = document.createElement('span'); text.textContent = value;
        label.append(input,text); sizeList.append(label);
      });
      sizeList.closest('fieldset').hidden = sizes.length === 0;
      const colorList = this.form.querySelector('[data-local-colors]');
      colorList.closest('fieldset').hidden = !colorList.querySelector('input');
      this.onChange = () => this.update();
      this.onApply = () => this.update();
      this.onReset = () => queueMicrotask(() => this.update());
      this.form.addEventListener('change', this.onChange);
      this.addEventListener('yrp-filters-apply', this.onApply);
      this.form.addEventListener('reset', this.onReset);
      this.update();
    }
    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('change', this.onChange);
      this.removeEventListener('yrp-filters-apply', this.onApply);
      this.form.removeEventListener('reset', this.onReset);
      this.records = null;
    }
    update() {
      const values = new FormData(this.form);
      const brand = values.get('brand'), sizes = values.getAll('size'), colors = values.getAll('color'), availability = values.get('availability');
      const sorted = [...this.records].sort((a,b) => values.get('sort') === 'price-asc' ? a.price-b.price || a.index-b.index : values.get('sort') === 'price-desc' ? b.price-a.price || a.index-b.index : a.index-b.index);
      let count = 0;
      for (const record of sorted) {
        const variantMatch = record.variants.some(variant => (!sizes.length || sizes.includes(variant.size)) && (!colors.length || colors.includes(variant.color) || colors.some(color => record.colors.includes(color))) && (availability !== '1' || variant.available));
        const visible = (!brand || record.brand === brand) && variantMatch && (availability === '' || record.available === (availability === '1'));
        record.card.hidden = !visible;
        if (visible) count++;
        this.grid.append(record.card);
      }
      this.grid.dataset.filtered = String(Boolean(brand || sizes.length || colors.length || availability));
      this.querySelector('.yrp-new-in-empty').hidden = count !== 0;
      const countText = this.dataset.countTemplate.replace('__COUNT__', String(count));
      this.querySelector('.yrp-new-in-count').textContent = this.grid.dataset.filtered === 'true' ? countText : '';
      const headerCount = document.querySelector('.yrp-collection-header__count');
      if (headerCount) headerCount.textContent = countText;
    }
  });
}
